import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import ActivitiesPopup from '../components/ActivitiesPopup';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const buildImageUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

const Activities = () => {
  const [activities, setActivities] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/activities`)
      .then((res) => {
        const normalized = res.data.map((activity) => ({
          ...activity,
          main_image: buildImageUrl(activity.main_image),
          images: Array.isArray(activity.images)
            ? activity.images.map((img) => buildImageUrl(img))
            : [],
        }));
        setActivities(normalized);
      })
      .catch((err) => console.error('Error al buscar actividades:', err));
  }, []);

  const handleOpen = (activity) => setSelectedActivity(activity);
  const handleClose = () => setSelectedActivity(null);

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      gap={4}
      justifyContent="center"
      p={5}
    >
      {activities.map((activity) => (
        <Box
          key={activity.id}
          onClick={() => handleOpen(activity)}
          sx={{
            width: 200,
            cursor: 'pointer',
            transition: 'transform 0.2s ease',
            '&:hover': {
              transform: 'translateY(-5px)',
            },
          }}
        >
          <Box
            sx={{
              height: 150,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
            }}
          >
            <Box
              component="img"
              src={activity.main_image}
              alt={activity.title}
              sx={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
            />
          </Box>
          <Box
            sx={{
              height: 48,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mt: 1,
              textAlign: 'center',
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 'bold',
                color: '#B3A6D2',
              }}
            >
              {activity.title}
            </Typography>
          </Box>
        </Box>
      ))}

      {selectedActivity && (
        <ActivitiesPopup
          open={!!selectedActivity}
          onClose={handleClose}
          activity={selectedActivity}
        />
      )}
    </Box>
  );
};

export default Activities;